const prefix = 'component_select_object/'

const type = {
    LOAD_LIST_OBJECTS: prefix + 'load_list_object',
    LOAD_LIST_OBJECTS_SUCCESS: prefix + 'load_list_object_success',
    SET_DEFAULT_CURRENT_OBJECT: prefix + 'set_default_current_object',
    UPDATE_CURRENT_OBJECT: prefix + 'update_current_object',
    SAVE_CURRENT_OBJECT: prefix + 'save_current_object',
    DELETE_OBJECT: prefix + 'delete_object',
    UPDATE_STATE: prefix + 'update_state',
    UPDATE_AVATAR: prefix + 'updateAvatar',

    CHANGE_PAGE_SIZE: prefix + 'change_page_size',
    CHANGE_CURRENT_PAGE: prefix + 'change_current_page',

    SHOW_MODAL_CURRENT_OBJECT_INFO: prefix + 'show_modal_current_object_info',
    DISMISS_MODAL_CURRENT_OBJECT_INFO:
        prefix + 'dismiss_modal_current_object_info',
    SHOW_MODAL_CONFIRM_DELETE_OBJECT:
        prefix + 'show_modal_confirm_delete_object',
    DISMISS_MODAL_CONFIRM_DELETE_OBJECT:
        prefix + 'dismiss_modal_confirm_delete_object',

    UPDATE_TEXT_SEARCH: prefix + 'update_text_search',
    SEARCH_OBJECT: prefix + 'search_object',

    UPDATE_SELECT_STATE_OBJECT: prefix + 'update_select_state_object',
    UPDATE_SELECTED_OBJECT: prefix + 'update_selected_object',
    GET_SUGGESTION_DATA: prefix + 'GET_SUGGESTION_DATA',
    GET_SUGGESTION_DATA_DONE: prefix + 'GET_SUGGESTION_DATA_DONE'
}

const action = {
    getSuggestionData : (textSearch) =>{
        return {
            type: type.GET_SUGGESTION_DATA,
            payload: {
                textSearch,
            },
        }
    },
    getSuggestionDataDone : (data) =>{
        return {
            type: type.GET_SUGGESTION_DATA_DONE,
            payload: {
                data,
            },
        }
    },
    loadListObject: params => {
        return {
            type: type.LOAD_LIST_OBJECTS,
            payload: {
                params,
            },
        }
    },
    loadListObjectsSuccess: objects => {
        return {
            type: type.LOAD_LIST_OBJECTS_SUCCESS,
            payload: {
                objects,
            },
        }
    },
    setDefaultCurrentObject: () => {
        return {
            type: type.SET_DEFAULT_CURRENT_OBJECT,
            payload: {},
        }
    },
    updateCurrentObject: object => {
        return {
            type: type.UPDATE_CURRENT_OBJECT,
            payload: {
                object,
            },
        }
    },
    saveCurrentObject: (extendData) => {
        return {
            type: type.SAVE_CURRENT_OBJECT,
            payload: {extendData},
        }
    },
    deleteObject: objectId => {
        return {
            type: type.DELETE_OBJECT,
            payload: {
                objectId,
            },
        }
    },
    updateState: state => {
        return {
            type: type.UPDATE_STATE,
            payload: {
                state,
            },
        }
    },
    changePageSize: pageSize => {
        return {
            type: type.CHANGE_PAGE_SIZE,
            payload: {
                pageSize,
            },
        }
    },
    changeCurrentPage: pageIndex => {
        return {
            type: type.CHANGE_CURRENT_PAGE,
            payload: {
                pageIndex,
            },
        }
    },
    showModalCurrentObjectInfo: () => {
        return {
            type: type.SHOW_MODAL_CURRENT_OBJECT_INFO,
            payload: {},
        }
    },
    dismissModalCurrentObjectInfo: () => {
        return {
            type: type.DISMISS_MODAL_CURRENT_OBJECT_INFO,
            payload: {},
        }
    },
    showModalConfirmDeleteObject: () => {
        return {
            type: type.SHOW_MODAL_CONFIRM_DELETE_OBJECT,
            payload: {},
        }
    },
    dismissModalConfirmDeleteObject: () => {
        return {
            type: type.DISMISS_MODAL_CONFIRM_DELETE_OBJECT,
            payload: {},
        }
    },
    updateAvatar: avatar => {
        return {
            type: type.UPDATE_AVATAR,
            payload: {
                avatar,
            },
        }
    },
    updateTextSearch: textSearch => {
        return {
            type: type.UPDATE_TEXT_SEARCH,
            payload: {
                textSearch
            }
        }
    },
    searchObject: () => {
        return {
            type: type.SEARCH_OBJECT,
            payload: {
                
            }
        }
    },
    updateSelectObjectState: (oid, selectState) => {
        return {
            type: type.UPDATE_SELECT_STATE_OBJECT,
            payload: {
                oid,
                selectState
            }
        }
    },
    updateSelectedObject: objects => {
        return {
            type: type.UPDATE_SELECTED_OBJECT,
            payload: {
                objects
            }
        }
    }
}

export default {
    type,
    action,
}
